<template>
    <component :is="layoutComponent">
        <slot></slot>
    </component>
</template>

<script setup>
import { computed } from 'vue';
import DefaultLayout from '@/layouts/Default.vue';
import BlankLayout from '@/layouts/Blank.vue';
import AnonymousLayout from '@/layouts/Anonymous.vue';

const props = defineProps({
  layout: {
    type: String,
    default: 'default'
  }
});

const layouts = {
    default: DefaultLayout,
    blank: BlankLayout,
    anonymous: AnonymousLayout
};

const layoutComponent = computed(() => layouts[props.layout] || layouts.default);
</script>